<template>
  <!-- prettier-ignore -->
  <div class="page1-main-container flex">
    <!-- 左侧聚合菜单 -->
    <subject-list-skeleton v-if="leftLoading && leftData.length === 0" variant="filter" />
    <left-menu
      v-else
      ref="leftMenuRef"
      v-show="leftData.length > 0"
      :leftData="leftData"
      :article="article"
      :showLetterFlag="showLetter"
      :delName="delName"
      :delSourceFrom="delSource"
      :delAll="delAll"
      :preSelectedSubject="preSelectedSubject"
      @childByValue="childByValue"
      @sourceByValue="sourceByValue"
      @clearPreSelectedSubject="clearPreSelectedSubject"
    ></left-menu>
    <!-- 右侧列表 -->
    <div class="page1-main">
      <!-- 筛选条件显示区域 -->
      <div class="right-top" v-if="conData.length > 0 || sourceList.length > 0">
        <div class="filter">
          筛选条件：
          <label
            v-for="(item, index) in sourceList"
            :key="'source-' + index"
            class="flex"
          >
            资源来源:
            {{ item == 1 ? "加入馆外资源更多结果" : "开放获取资源" }}
            <i class="el-icon-close" @click="handleDelSource(item)"></i>
          </label>
          <label v-for="(item, index) in conData" :key="'cond-' + index" class="flex">
            {{ item.fatherName }}: {{ item.name }}
            <i class="el-icon-close" @click="handleDelName(item)"></i>
          </label>
          <label
            v-if="hasActiveFilters"
            class="clear-all flex"
            @click="clearAllFilters"
          >
            清空全部
            <i class="el-icon-close"></i>
          </label>
        </div>
      </div>

    <div class="search_total">
      <p class="total">
        <span>{{ listTotal }}</span
        >条论文数据
      </p>
      <div class="search">
        <el-input v-model="topHotWords" placeholder="请输入检索词" style="flex: 1;" @keyup.enter.native="toSearch" clearable></el-input>
        <span class="search_img" @click="toSearch">
          <img src="../../assets/images/search_icon.png"/>
        </span>
      </div>
    </div>
    <subject-list-skeleton v-if="loading" variant="article" />
    <ul v-else>
      <li class="flex" v-for="(item, index) in list" :key="index">
        <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
        <div class="right-info">
          <p @click="toDetail(index)">
            <span v-safe-html="item.title"></span>
            <!-- <label :class="getColor(item.oaType)" v-safe-html="getoatext(item.oaType)"></label> -->
          </p>
          <p v-if="item.authorArray && item.authorArray.length > 0">
            作者：<span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
              <span class="span_a" @click="toAuthorDetail(element)" v-safe-html="element.authorName"></span>
              <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
              <div class="author-content">
                <p class="mb10" v-safe-html="element.authorName"></p>
                <p>
                  <span v-if="element.hindex != null"
                    >hindex：<label>{{ element.hindex }}</label></span
                  >
                  <span v-if="element.i10Index != null"
                    >i10Index：<label>{{ element.i10Index }}</label></span
                  >
                </p>
                <p>
                  <span v-if="element.citedByCount != null"
                    >citedByCount：<label>{{ element.citedByCount }}</label></span
                  >
                  <span v-if="element.worksCount != null"
                    >worksCount：<label>{{ element.worksCount }}</label></span
                  >
                </p>
                <p class="hui">{{ element.lastKnownInstitutionName }}</p>
              </div>
            </span>
            <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
            <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
          </p>
          <p v-if="item.journalName">
            期刊信息：<span @click="toHomeDetail(item)"> <span class="undline" v-safe-html="item.journalName"></span>; </span>
            <label v-if="item.year">{{ item.year }} ; </label>
            {{ item.volume }}
            <label v-if="item.issue && item.issue != 'null'">({{ item.issue }})</label>
          </p>
          <p v-if="item.doi">DOI：<span v-safe-html="item.doi"></span></p>
          <p v-if="item.hingeWord">
            关键词：<span class="fenhao" v-for="(element, idx) in item.hingeWordArray" :key="idx">
              <label v-safe-html="element"></label>
              <label v-if="idx < item.hingeWordArray.length - 1">;</label>
            </span>
          </p>
          <!-- <p v-if="item.source">来源: {{ item.source }}</p> -->
          <div class="btn-p flex">
            <p class="num-tips" v-if='item.citedCount'>
              引用量：<span>{{ item.citedCount }}</span>
            </p>
            <p class="num-tips" v-if="item.fwci" style='margin-left:10px;'>
              影响力指数：<span>{{ item.fwci }}</span>
            </p>
            <div class="btn-right">
              <div @click.stop class="flex">
                <div class="btn" v-if="roles && item.gainLiteratureState === true && item.source !== '商业资源' " @click="getResource(item, index)" :class="{ noCourse: item.btnLoading }">
                  <img class="rotating-image" v-if="item.btnLoading" src="../../assets/images/loading_s.svg" />
                  <img class="img" src="../../assets/images/icon-qwhq-mr.png" />
                  <img class="hover-img" src="../../assets/images/icon-qwhq-xz.png" />全文获取
                </div>
                <div class="achieve" v-if="Resourcelist == item.openAlexId" v-loading="achieveloading" ref="showPanel">
                  <div class="achieve-li">
                    <li v-for="(bookitem, index) in liblist" :key="index" class="1">
                      <a v-safe-html="bookitem.shortName" @click="libdetailUrl(item, bookitem)"></a>
                    </li>
                    <li v-if="gainResource.provideType == '3'" @click="recommendrecord(item)">
                      <a>推荐</a>
                    </li>
                    <li v-if="gainResource.provideType == '2'" @click="getResourceDetail(item, gainResource)">
                      <a>单篇采选</a>
                    </li>
                    <li v-if="gainResource.provideType == '1'" @click="getDeliverSave(item)">
                      <a>文献传递</a>
                    </li>
                    <li v-if="gainResource.provideType == '5'" @click="getLiterature(item)">
                        <a>请求获取</a>
                      </li>
                      <li v-if="paperData.baiduXueShuExist">
                            <a @click="goBaidu(paperData.baiduXueShuLink)">百度学术</a>
                          </li>
                    <li v-if="qingqiuhuoqu">
                      <a @click="getQingqiu(item)">请求获取</a>
                      <!-- <font><i class="el-icon-info"></i>我们在一天内进行处理，请您稍后重新打开界面获取。</font> -->
                    </li>
                  </div>
                </div>
              </div>
              <div class="flex" @click="copylist(item.sid)">
                <img
                  src="../../assets/images/icon-fz-mr.png"
                  class="img"
                />
                <img
                  src="../../assets/images/icon-fz.png"
                  class="hover-img"
                />复制
              </div>
              <div class="flex" @click="showReference(item)">
                <img class="img" src="../../assets/images/icon-yy-mr.png" />
                <img class="hover-img" src="../../assets/images/icon-yy-xz.png" />引用
              </div>
              <!-- <div class="flex" :class="{ checked: item.share }" @click="isCollect(item)" v-if="!info.ipUser">
                <img class="img" :src="item.share ? collectTrue : collectFalse" />
                <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />收藏
                <i class="share" v-if="item.shareCount > 0">{{ item.shareCount }}</i>
              </div> -->
              <div class="flex" :class="{ checked: item.share }" @click="getFolderList(item.sid, item.share)" v-if="!info.ipUser">
                <img class="img" :src="item.share ? collectTrue : collectFalse" />
                <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />收藏
                <i class="share" v-if="item.shareCount > 0">{{ item.shareCount }}</i>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div class="noData" v-if="total <= 0 && !orderField && !loading">
      <img src="../../assets/images/noData.png" />
    </div>
     <div class="noData" v-if="total <= 0 && orderField && !loading">
       <el-empty description="暂无数据"></el-empty>
    </div>
    <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>

    <el-dialog title="引用" :visible.sync="referenceDialog" width="30%">
      <div class="dialog-content">
        <ul class="dialog-tab">
          <li @click="changeDialogTab(1)" :class="{ dialogChecked: dialogIndex == 1 }">BIB</li>
          <li @click="changeDialogTab(2)" :class="{ dialogChecked: dialogIndex == 2 }">CITE</li>
        </ul>
        <div class="tab1" v-if="dialogIndex == 1">
          <ul>
            <li>
              <p class="flex">
                <span @click="copyContent(BIBObj)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">{{ BIBObj }}</div>
            </li>
          </ul>
        </div>
        <div class="tab1" v-if="dialogIndex == 2">
          <ul>
            <li v-for="(item, index) in CITEArray" :key="index">
              <p class="flex line">
                <label>{{ item.name }}</label>
                <span @click="copyContent(item.value)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">
                {{ item.value }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="down-dialog-footer">
        导出为
        <span @click="handleExport('bib')">BibTex</span>
        <span @click="handleExport('endnote')">EndNote</span>
      </span>
    </el-dialog>
    <el-dialog
      title="收藏"
      :visible.sync="addFodlerDialog"
      width="25%"
      class="add_folder_dialog"
    >
      <div class="add_dialog_folder" ref="myScroll">
        <ul>
          <li v-for="(item, index) in folderList" :key="index">
            <div
              class="div_folder li_folder"
              v-if="!item.addFlag"
              @click="handleChoiseFolder(index)"
            >
              <div>
                <img src="../../assets/images/icon-wjj-mr.png" />{{ item.name }}
              </div>
              <!-- <span v-if="item.exist">已存在</span> -->
              <i
                class="el-icon-check"
                v-if="folderIndex === index || (!checkFolder && item.exist)"
              ></i>
            </div>
            <div class="div_folder new_folder" v-else>
              <img src="../../assets/images/icon-wjj-xz.png" alt="" />
              <el-input
                placeholder="请输入文件夹名称"
                v-model="item.name"
                maxlength="20"
                @keyup.enter.native="submitAddFolder($event)"
              ></el-input>
              <span @click.stop="cannalFolder()"
                ><i class="el-icon-close"></i
              ></span>
              <span
                ><i
                  class="el-icon-check"
                  @click.stop="submitAddFolder($event)"
                ></i
              ></span>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <p @click="newAddFolder">
          <i class="el-icon-folder-add"></i>新建文件夹
        </p>
        <div>
          <el-button @click="addFodlerDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitFolder">确 定</el-button>
        </div>
      </span>
    </el-dialog>
        <el-dialog title="绑定手机号" :visible.sync="phoneDialog" width="25%">
      <el-input
        placeholder="请输入手机号"
        v-model="phone"
        maxlength="20"
        @keyup.enter.native="submitAddphone($event)"
        class="phone-input"
      ></el-input>
      <div class="flex phone">
        <el-input placeholder="验证码" v-model="code" />
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
      <div class="flex phonebtn">
        <el-button @click="phoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddphone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请求获取文献" :visible.sync="literatureDialogVisible" width="420px" :before-close="handleLiteratureClose">
      <div class="literature-dialog-content">
        <p class="literature-tip-sm">声明：请求的文献仅用于科研与教学使用，不做非法传播、复制</p>
        <p class="literature-tip">请正确输入邮箱，文献请求获取结果会以邮箱方式通知!</p>
        
        <el-form :model="literatureForm" :rules="literatureRules" ref="literatureFormRef">
          <el-form-item prop="email">
            <el-input v-model="literatureForm.email" placeholder="请输入邮箱地址" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer-right">
        <el-button @click="handleLiteratureClose">取 消</el-button>
        <el-button type="primary" @click="submitLiterature">确 定</el-button>
      </span>
    </el-dialog>
    </div><!-- 结束 page1-main -->
  </div>
  <!-- 结束 page1-main-container -->
</template>

<script>
import baseurl from "../../api/baseurl";
import LeftMenu from "@/components/leftMenu.vue";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";
import { oaColor } from "../../assets/js/oacolor";
import { oaText } from "../../assets/js/oacolor";
import Axios from "axios";

export default {
  components: { LeftMenu, SubjectListSkeleton },
  props: {
    parentData: {
      type: String,
      default: "",
    },
    parentConceptName: {
      type: String,
      default: "",
    },
    parentConceptId: {
      type: String,
      default: "",
    },
    parentHotWords: {
      type: String,
      default: "",
    },
    parentYears: {
      type: String,
      default: "",
    },
    orderField: {
      type: String,
      default: "",
    },
    newCount: {
      type: [Number, String], // 允许两种类型
      default: 0,
    },
    isNumListPage: {
      type: Boolean,
      default: false,
    },
    newData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      leftLoading: false,
      activeName: "1",
      list: [],
      pageSize: 10,
      pageNo: 1,
      total: 0,
      listTotal: 0,
      // 左侧聚合相关数据
      leftData: [],
      showLetter: false, // 左侧聚合是否显示首字母
      delName: null,
      delSource: 0,
      delAll: 0,
      conData: [], // 条件的过滤
      filterData: [],
      sourceList: [],
      preSelectedSubject: null, // 存储预选中的学科信息
      isUpdatingFromChildMethod: false, // 标志位：是否从 childMethod 触发的更新
      dialogIndex: 1,
      BIBObj: null,
      CITEArray: [],
      collectFalse: require("../../assets/images/icon-sc-mr.png"),
      collectTrue: require("../../assets/images/icon-sc-xz.png"),
      roles: true,
      Resourcelist: false,
      referenceDialog: false,
      keyWords: "",
      hotWords: "",
      info: "",
      //文件夹
      addFodlerDialog: false,
      folderList: [],
      folderIndex: null,
      checkFolder: false,
      foldershare: false,
      year: "",
      influence: "",
      influenceList: [
        {
          name: "大于1",
          value: 10,
        },
        {
          name: "等于1",
          value: 20,
        },
        {
          name: "小于1",
          value: 30,
        },
      ],
      journalVal: "",
      journalList: null,
      journalFlag: false,
      topHotWords: "",
      // 查询参数
      searchWord: "",
      searchFields: [],
      // orderField: "publishDate", // publishDate 最新，citedCount最高引用
      orderType: "DESC", // 固定
      paramList: [],
      sourceList: [],
      publishYearStart: "",
      publishYearEnd: "",
      metricFilterList: [], //聚合参数集
      subjectname: "",
      phoneDialog: false,
      show: true,
      phone: "",
      code: "",
      times: 60,
      currentResourceItem: null, // 存储当前资源项
      article: "check", //标识是否是文章
      searchKeyword: "",
      nullFilterList: "",
      literatureDialogVisible: false,
      literatureItem: null,
      literatureForm: {
        email: "",
      },
      literatureRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
      paperData: "",
    };
  },
  computed: {
    // 检查conData中是否已经有学科筛选条件
    hasSubjectInConData() {
      return this.conData.some(item => item.fatherName === "外文学科" || item.fatherName === "学科" || (item.filterField && item.filterField === "secondSubject"));
    },
    hasActiveFilters() {
      return this.sourceList.length > 0 || (this.preSelectedSubject && this.preSelectedSubject.id && !this.hasSubjectInConData) || this.conData.length > 0;
    },
  },
  watch: {
    parentData(val) {
      this.pageNo = 1;
      this.keyWords = val;
      this.getArticleList();
    },
    parentConceptName: {
      immediate: true,
      handler(val) {
        if (!val || this.isUpdatingFromChildMethod) {
          return;
        }
        this.pageNo = 1;
        this.nullFilterList = [];
        this.subjectname = val;
        this.getnewData();
        this.getLeftList();
      },
    },
  },
  mounted() {
    //点击空白关闭弹出
    document.addEventListener("click", this.bodyCloseMenus);
    if (localStorage.getItem("roles")) {
      let roleArr = localStorage.getItem("roles").split(",");
      roleArr.forEach(element => {
        if (element == "other") {
          this.roles = false;
        }
      });
    }
    this.keyWords = this.parentData;
    if (this.$route.query.years) {
      this.year = this.$route.query.years;
    }
    if (this.$route.query.words) {
      this.topHotWords = this.$route.query.words;
    } else {
      this.topHotWords = "";
    }
    if (this.keyWords) {
      this.getArticleList();
    }
    // this.getInfo();
  },
  methods: {
    toSearch() {
      this.pageNo = 1;
      this.getArticleList();
      if (this.orderField) {
        this.pageNo = 1;

        this.getnewData();
        this.getLeftList();
      }
    },
    // 左侧聚合回调 - 接收选中的筛选条件
    childByValue(obj) {
      this.filterData = obj.newNarr;
      this.conData = obj.filterArray;
      this.pageNo = 1;
      // 当用户从左侧聚合选择筛选条件时，重新获取数据
      if (this.orderField) {
        this.getnewData();
        this.getLeftList();
      }
    },
    // 资源来源回调
    sourceByValue(val) {
      this.sourceList = val;
      this.pageNo = 1;
      // 当资源来源变化时，重新获取数据
      if (this.orderField) {
        this.getnewData();
        this.getLeftList();
      }
    },
    // 清除预选中学科
    clearPreSelectedSubject() {
      this.preSelectedSubject = null;
      sessionStorage.removeItem("subjectSearchInfo");
    },
    // 删除单个筛选条件
    handleDelName(item) {
      this.delName = item;
      this.conData = this.conData.filter(element => element.onlyFlag !== item.onlyFlag);
      this.filterData = this.filterData.filter(element => {
        if (element.filterValue) {
          const index = element.filterValue.indexOf(item.filterValue);
          if (index > -1) {
            element.filterValue.splice(index, 1);
          }
          return element.filterValue.length > 0;
        }
        return true;
      });
      this.pageNo = 1;

      // 删除筛选条件后重新获取数据和左侧聚合
      if (this.orderField) {
        this.getnewData();
        this.getLeftList();
      }
    },
    // 删除资源来源
    handleDelSource(item) {
      this.delSource = item;
      this.sourceList = this.sourceList.filter(element => element !== item);
      this.pageNo = 1;
      // 删除资源来源后重新获取数据和左侧聚合
      if (this.orderField) {
        this.getnewData();
        this.getLeftList();
      }
    },
    // 清空全部筛选条件
    clearAllFilters() {
      this.delAll++;
      this.conData = [];
      this.filterData = [];
      this.sourceList = [];
      this.preSelectedSubject = null;
      sessionStorage.removeItem("subjectSearchInfo");
      this.pageNo = 1;
      // 清空后重新获取数据和左侧聚合
      if (this.orderField) {
        this.getnewData();
        this.getLeftList();
      }
    },
    childMethod(odertype, val) {
      // 处理从父组件接收的参数
      this.isUpdatingFromChildMethod = true; // 设置标志位，阻止 watch parentConceptName 触发
      this.orderField = odertype;
      this.subjectname = val;
      this.pageNo = 1;

      this.getnewData();
      this.getLeftList(); // 学科切换时更新左侧聚合
      // 使用 $nextTick 在下一个 tick 清除标志位
      this.$nextTick(() => {
        this.isUpdatingFromChildMethod = false;
      });
    },
    // 期刊方法
    searchJournal() {
      this.$http({
        url: "api/v1/concept/journal/suggestion?word=" + this.journalVal,
        method: "get",
      }).then(res => {
        this.journalList = res.data;
        if (this.journalList.length > 0) {
          this.journalFlag = true;
        }
      });
    },
    handleJournal(item) {
      this.journalVal = item.suggestionWord.split("<span style='color:#15babc'>").join("").split("</span>").join("");
      this.journalSid = item.sid;
      this.pageNo = 1;
      this.journalFlag = false;
      this.getArticleList();
    },
    handleClear() {
      this.journalSid = "";
      this.pageNo = 1;
      this.getArticleList();
    },
    handleSearch() {
      this.pageNo = 1;
      this.getArticleList();
    },
    handleYearSearch() {
      this.pageNo = 1;
      this.getArticleList();
      let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 先拷贝一个一模一样的对象
      delete newQuery.years; //再删除page
      this.$router.replace({ query: newQuery });
    },
    clearSearch() {
      this.topHotWords = "";
      this.year = "";
      this.influence = "";
      this.journalSid = "";
      this.journalVal = "";
      this.pageNo = 1;
      this.getArticleList();
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    clearHotWords() {
      this.year = "";
      this.pageNo = 1;
      this.topHotWords = "";
      this.getArticleList();
      let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 先拷贝一个一模一样的对象
      delete newQuery.words; //再删除page
      this.$router.replace({ query: newQuery });
    },
    // 获取左侧聚合数据
    getLeftList() {
      let array = [];
      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
          type: element.fatherName == "资源来源" ? "metric" : null,
        });
      });
      if (this.nullFilterList) {
        array = this.nullFilterList;
      }
      if (this.subjectname && this.orderField) {
        const hasSubjectFilter = array.some(item => item.filterField === "secondSubject.raw" && item.filterValue.includes(this.subjectname));
        if (!hasSubjectFilter) {
          array.push({
            filterField: "secondSubject.raw",
            filterValue: [this.subjectname],
            type: null,
          });
        }
      }
      // 处理从Header传递过来的学科信息，作为筛选条件
      if (this.preSelectedSubject && this.preSelectedSubject.id && this.preSelectedSubject.name) {
        const hasSubjectFilter = array.some(item => item.filterField === "secondSubject" && item.filterValue.includes(this.preSelectedSubject.name));
        const hasLeftMenuSubjectFilter = this.filterData.some(item => item.filterField === "secondSubject");
        if (!hasSubjectFilter && !hasLeftMenuSubjectFilter) {
          array.push({
            filterField: "secondSubject",
            filterValue: [this.preSelectedSubject.name],
            type: null,
          });
        }
      }
      let postBody = {
        searchWord: this.topHotWords,
        searchFields: [],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.orderField || "publishDate",
        orderType: "DESC",
        metricFilterList: array,
        paramList: [],
        sourceList: this.sourceList.length > 0 ? this.sourceList : [],
        publishYearStart: "",
        publishYearEnd: "",
      };

      this.leftLoading = true;
      this.$http({
        url: "/api/v1/reception/journalpaper/listAgg2",
        method: "POST",
        data: postBody,
      })
        .then(res => {
          this.leftLoading = false;

          // 验证响应数据
          if (!res.data) {
            console.error("接口返回数据为空:", res);
            this.leftData = [];
            return;
          }

          if (!res.data.left || !Array.isArray(res.data.left)) {
            console.error("左侧聚合数据格式错误:", res.data);
            this.leftData = [];
            return;
          }

          // 过滤掉"外文学科"聚合项
          const filteredLeft = res.data.left.filter(element => {
            return element.name !== "外文学科";
          });

          // 如果过滤后没有数据，直接返回
          if (filteredLeft.length === 0) {
            console.warn("过滤后左侧聚合数据为空");
            this.leftData = [];
            return;
          }

          filteredLeft.forEach(element => {
            if (element.name == "核心期刊" || element.name == "学科分类") {
              element.drop = true;
              element.dropNum = element.items.length;
            } else {
              element.dropNum = 5;
            }
          });

          // 使用 $set 确保响应式更新
          this.$set(this, "leftData", filteredLeft);

          // 强制触发一次渲染
          this.$nextTick(() => {
            this.$forceUpdate();
          });

          // 如果有预选中的学科信息，在左侧数据加载完成后触发预选中
          if (this.preSelectedSubject) {
            this.$nextTick(() => {
              if (this.$refs && this.$refs.leftMenuRef) {
                this.$refs.leftMenuRef.selectSubjectByInfo(this.preSelectedSubject);
              }
            });
          }
        })
        .catch(error => {
          console.error("获取左侧聚合数据失败:", error);
          this.leftLoading = false;
          this.leftData = [];
        });
    },
    //获取最新文献
    getnewData() {
      let array = [];
      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
          type: element.fatherName == "资源来源" ? "metric" : null,
        });
      });

      // 确保当前学科筛选条件始终存在
      if (this.subjectname && this.orderField) {
        const hasSubjectFilter = array.some(item => item.filterField === "secondSubject.raw" && item.filterValue.includes(this.subjectname));
        if (!hasSubjectFilter) {
          array.push({
            filterField: "secondSubject.raw",
            filterValue: [this.subjectname],
            type: null,
          });
        }
      }

      let postBody = {
        searchWord: this.topHotWords,
        searchFields: [],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.orderField, // publishDate 最新，citedCount最高引用
        orderType: "DESC", // 固定
        metricFilterList: array,
        paramList: [],
        sourceList: this.sourceList.length > 0 ? this.sourceList : [],
        publishYearStart: "",
        publishYearEnd: "",
      };
      this.loading = true;
      this.$http({
        url: "/api/v1/reception/journalpaper/list2",
        method: "post",
        data: postBody,
      }).then(res => {
        // 判断返回数量是否等于零
        if (res.data.recordCount === 0) {
          // 根据当前学科获取对应父学科下的所有子学科
          this.getParentSubjectChildren().then(childrenNames => {
            if (childrenNames && childrenNames.length > 0) {
              // 使用父学科下的所有子学科重新调用接口
              // postBody.metricFilterList[0].filterValue = childrenNames;
              // 创建新的请求体，避免修改原始对象
              const retryPostBody = {
                ...postBody,
                metricFilterList: postBody.metricFilterList.map((item, index) => {
                  if (item.filterField === "secondSubject.raw") {
                    return {
                      ...item,
                      filterValue: childrenNames,
                    };
                  }
                  return item;
                }),
              };
              this.nullFilterList = retryPostBody.metricFilterList;
              this.getLeftList();
              this.$http({
                url: "/api/v1/reception/journalpaper/list2",
                method: "post",
                data: retryPostBody,
              }).then(retryRes => {
                this.handleDataResponse(retryRes);
              });
            } else {
              // 如果获取不到子学科，使用原始数据
              this.handleDataResponse(res);
            }
          });
        } else {
          this.handleDataResponse(res);
        }
      });
    },
    // 处理数据响应的公共方法
    handleDataResponse(res) {
      this.list = res.data.recordList;
      this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
      this.listTotal = res.data.recordCount;
      this.loading = false;
      this.list.forEach((element, index) => {
        if (element.hingeWord) {
          this.list[index].hingeWordArray = element.hingeWord.split(";");
        }
        if (element.authorList && element.authorList.length > 0) {
          this.$set(this.list[index], "authorAllArray", element.authorList);
          this.$set(this.list[index], "authorArray", element.authorList.slice(0, 5));
        }
        element.showauthor = true; //作者展开收起标识
      });
    },
    // 根据当前学科获取父学科下的所有子学科
    getParentSubjectChildren() {
      return new Promise(resolve => {
        // 获取当前学科信息
        const currentSubjectName = this.subjectname;
        if (!currentSubjectName) {
          resolve([]);
          return;
        }

        // 查找父学科的辅助函数
        const findParentSubject = (treeData, subjectName) => {
          if (!treeData || treeData.length === 0) {
            return null;
          }
          for (let i = 0; i < treeData.length; i++) {
            const firstLevel = treeData[i];
            if (firstLevel.childrenList && firstLevel.childrenList.length > 0) {
              const foundChild = firstLevel.childrenList.find(child => child.name === subjectName || child.cnName === subjectName);
              if (foundChild) {
                return firstLevel;
              }
            }
          }
          return null;
        };

        // 获取学科树结构，根据当前学科名称搜索
        this.$http({
          url: `api/v1/subject/gateway/topic/tree?name=${encodeURIComponent(currentSubjectName)}&isZh=true`,
          method: "GET",
        })
          .then(res => {
            let parentSubject = findParentSubject(res.data, currentSubjectName);

            if (parentSubject && parentSubject.childrenList && parentSubject.childrenList.length > 0) {
              // 找到父学科，返回所有子学科的名称
              const childrenNames = parentSubject.childrenList.map(child => child.name || child.cnName);
              resolve(childrenNames);
            } else {
              // 如果通过搜索没找到，尝试获取全部学科树
              this.$http({
                url: "api/v1/subject/gateway/topic/tree?name=&isZh=true",
                method: "GET",
              })
                .then(allRes => {
                  parentSubject = findParentSubject(allRes.data, currentSubjectName);
                  if (parentSubject && parentSubject.childrenList && parentSubject.childrenList.length > 0) {
                    const childrenNames = parentSubject.childrenList.map(child => child.name || child.cnName);
                    resolve(childrenNames);
                  } else {
                    resolve([]);
                  }
                })
                .catch(() => {
                  resolve([]);
                });
            }
          })
          .catch(() => {
            resolve([]);
          });
      });
    },
    // 文章列表
    getArticleList() {
      // 如果有测试数据，不调用API
      // if (this.orderField) {
      //   console.log("有测试数据，跳过API调用");
      //   return;
      // }
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyword: this.topHotWords,
        conceptId: this.parentConceptId,
        journalSid: this.journalSid,
        year: this.year,
        fwci: this.influence,
      };
      this.loading = true;
      this.$http({
        url: "api/v1/concept/thesis/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.list = res.data.recordList;
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;

        this.list.forEach((element, index) => {
          if (element.hingeWord) {
            this.list[index].hingeWordArray = element.hingeWord.split(";");
          }
          if (element.authorList && element.authorList.length > 0) {
            this.$set(this.list[index], "authorAllArray", element.authorList);
            this.$set(this.list[index], "authorArray", element.authorList.slice(0, 5));
          }
          element.showauthor = true; //作者展开收起标识
        });
      });
    },
    //oa状态
    getColor(item) {
      return oaColor(item);
    },
    getoatext(item) {
      return oaText(item);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      if (this.orderField) {
        this.getnewData();
      } else {
        this.getArticleList();
      }
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      if (this.orderField) {
        this.getnewData();
      } else {
        this.getArticleList();
      }
    },

    changeDialogTab(index) {
      this.dialogIndex = index;
    },
    //作者展开收起
    showauthor(index) {
      this.list[index].showauthor = false;
      this.list[index].authorArray = this.list[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.list[index].showauthor = true;
      this.list[index].authorArray = [];

      for (let i = 0; i < 5; i++) {
        this.list[index].authorArray.push(this.list[index].authorList[i]);
      }
      this.$forceUpdate();
    },
    // 引用
    showReference(item) {
      this.dialogIndex = 1;
      this.exportSid = item.sid;
      this.$http({
        url: `api/v1/reception/journalpaper/getReference?sid=${item.sid}`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.BIBObj = res.data.bib;
          this.CITEArray = [];
          if (res.data.mla) {
            this.CITEArray.push({
              name: "MLA",
              value: res.data.mla,
            });
          }
          if (res.data.apa) {
            this.CITEArray.push({
              name: "APA",
              value: res.data.apa,
            });
          }
          if (res.data.chicago) {
            this.CITEArray.push({
              name: "Chicago",
              value: res.data.chicago,
            });
          }
          if (res.data.gb) {
            this.CITEArray.push({
              name: "GB",
              value: res.data.gb,
            });
          }
          this.referenceDialog = true;
        }
      });
    },
    // 文献传递
    getDeliverSave(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/deliver/apply/sys/save?openAlexId=" + item.openAlexId,
        method: "get",
      }).then(res => {
        window.open(`/asp/myDeliver`, "_self");
        // this.$message.success("文献传递成功，请到个人中心我的文献传递中查看~");
      });
    },
    // 文献请求获取 弹出一个弹框输入邮箱
    getLiterature(item) {
      this.Resourcelist = false;
      this.literatureItem = item;
      this.literatureForm.email = "";
      this.literatureDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.literatureFormRef) {
          this.$refs.literatureFormRef.clearValidate();
        }
      });
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.code == 200 && res.data && res.data.email) {
          this.literatureForm.email = res.data.email;
        }
      });
    },
    handleLiteratureClose() {
      this.$refs.literatureFormRef.resetFields();
      this.literatureDialogVisible = false;
    },
    submitLiterature() {
      this.$refs.literatureFormRef.validate(valid => {
        if (!valid) return;
        this.literatureDialogVisible = false;
        this.Resourcelist = false;
        this.$http({
          url: "/api/v1/literature-gain-apply/save",
          method: "POST",
          data: {
            paperSid: this.literatureItem.sid,
            email: this.literatureForm.email,
          },
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("请求获取成功，文献获取通知将发送到您的邮箱");
          }
        });
      });
    },
    // 百度学术
    goBaidu(url) {
      window.open(url);
    },
    // 请求获取
    getQingqiu(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/literature-gain-apply/save",
        method: "post",
        data: {
          paperSid: item.sid,
        },
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("请求成功，我们将在一天内进行处理，请您稍后在文献服务平台 - 我的申请 - 我的文献申请中获取!");
          this.qingqiuhuoqu = false;
        }
      });
    },
    //推荐
    recommendrecord(item) {
      this.Resourcelist = false;
      this.$http({
        url: "api/v1/advice/record/save/sys?openAlexId=" + item.openAlexId,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("推荐成功");
        } else {
          this.$message.error("推荐失败");
        }
      });
    },
    //获取全文
    getResource(item, index) {
      // 1, “馆藏”
      // 2, “OA”
      // 3, “非馆藏非OA”
      // 5, “采购”

      // 10, “未登录”
      // if (item.source == "馆外资源") {
      //   this.Resourcelist = false;
      //   this.$message.error("馆外无法获取资源");
      //   this.achieveloading = false;
      //   return;
      // }
      if (this.list[index].btnLoading) {
        return;
      }
      this.list[index].btnLoading = true;
      this.$forceUpdate();

      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      let postBody = {
        doi: this.detaildoi,
        openAlexId: item.openAlexId,
      };
      this.$http({
        url: "api/v1/wantbuyR/queryPaper",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.data) {
          this.list[index].btnLoading = false;
          this.$forceUpdate();
          this.paperData = res.data;
          this.qingqiuhuoqu = false;
          this.Resourcelist = false;
          this.gainResource = {};
          this.liblist = [];

          if (res.data.state == 1) {
            this.Resourcelist = res.data.openAlexId;
            this.liblist = res.data.ebookNameList;
            this.achieveloading = false;
          } else if (res.data.state == 2) {
            // 显示请求获取按钮
            this.Resourcelist = res.data.openAlexId;
            this.qingqiuhuoqu = true;
            this.achieveloading = false;
            // if (res.data.detailUrl) {
            //   window.open(res.data.detailUrl);
            // } else {
            //   this.$router.push({ path: "fourfour" });
            // }
          } else if (res.data.state == 3) {
            this.Resourcelist = res.data.openAlexId;
            this.gainResource = res.data.gainResourceBo;
            if (res.data.gainResourceBo.provideType === 4) {
              this.Resourcelist = false;
              this.$message.error("馆外无法获取资源");
              this.achieveloading = false;
              return;
            }
            this.achieveloading = false;
          } else if (res.data.state == 63) {
            window.open(
              `http://lib.cqu.edu.cn/articlesearch/web_searchingResult?key={"rule":{"ruleBody":"DI=[@DI_79107149_0_f]","ruleParameters":[{"key":"@DI_79107149_0_f","value":"${this.detaildoi}"}]},"filterRule":{"ruleBody":"TY=[@TY_96453382_0_f]","ruleParameters":[{"key":"@TY_96453382_0_f","value":"3"}]}}&keyword=${this.detaildoi}`,
            );
          } else if (res.data.state == 5 || res.data.state == 6 || res.data.state == 7) {
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.applyPaperSourceSid}&type=${res.data.state}`,
              method: "get",
            }).then(downres => {
              if (downres.code == 200) {
                // 采购下载
                if (res.data.state == 5) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/purchase/download?uid=" + downres.data);
                }
                // 文献传递下载
                if (res.data.state == 6) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/deliver/download?uid=" + downres.data);
                }
                // 个人上传文件下载
                if (res.data.state == 7) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/person/download?uid=" + downres.data + "&openAlexId=" + res.data.openAlexId);
                }
              }
            });
          } else if (res.data.state == 10) {
            // this.$router.push({ path: "/lg", query: { word: true } });
            this.$message.warning("该资源的全文仅限用户登录后获取，请先登录");
            // window.open(`/lg?word=true&isback=true`, "_self");
          } else if (res.data.state == 20) {
            //oa附件  下载附件
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.openAlexId}&type=${res.data.state}`,
              method: "get",
            }).then(res => {
              if (res.code == 200) {
                window.open(baseurl.baseUrl + "api/v1/wantbuyR/oa/download?uid=" + res.data);
              }
            });
          } else if (res.data.state == 52) {
            let title = "";
            let doi = "";
            if (res.data.doi) {
              doi = res.data.doi;
            } else {
              //个别数据会有\n 去除\n
              if (res.data.title.includes("\n")) {
                title = res.data.title.split("\n").join("");
              } else {
                title = res.data.title;
              }
              doi = title;
            }
            let str = '{"query":{"query_string":{"query":"' + doi + '","default_operator":"AND"}},"track_total_hits":true}';
            let query = encodeURIComponent(str);
            window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
          }
        }
      });
    },
    getResourceDetail(item) {
      this.Resourcelist = false;
      this.currentResourceItem = item;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (!res.data.phone) {
          this.code = "";
          this.phone = "";
          clearInterval(this.timer);
          this.show = true;
          this.phoneDialog = true;
          return;
        }
        if (item.doi) {
          this.detaildoi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        } else {
          this.detaildoi = "";
        }
        let postBody = {
          doi: this.detaildoi,
          openAlexId: item.openAlexId,
        };
        this.$http({
          url: "/api/v1/promote/wantbuy/getResource",
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.data.state == 2) {
            this.$message.success("您已提交过申请");
            return;
          }
          if (res.data.state == 3) {
            this.$message.success("订单是否有对应DOI,订购中");
            return;
          }
          if (res.data.state == 4) {
            this.$message.success("供应商暂不提供该资源");
            return;
          }
          if (res.data.state == 5) {
            this.$message.success("符合采选规则,获取成功");
            return;
          }
          // 不符合采选规则,待申请
          if (res.data.state == 6) {
            // 申请
            let dataBody = {
              doi: res.data.doi,
              title: res.data.title,
              paperPrice: res.data.paperPrice,
              singlePrice: res.data.singlePrice,
              totalPrice: res.data.totalPrice,
              badWord: res.data.badWord,
              supplierId: res.data.supplierId,
            };
            this.$http({
              url: "/api/v1/promote/wantbuy/apply",
              method: "POST",
              data: dataBody,
            }).then(respones => {
              this.$message.success(respones.data);
            });

            return;
          }
          if (res.data.state == 8) {
            //已提交过申请
            this.$message.success("资源被图书馆收录");
            return;
          }
          if (res.data.state == 21) {
            //系统繁忙
            this.$message.error("系统繁忙，请稍后重试");

            return;
          }
          if (res.data.state == 22) {
            //资源申请成功
            this.$message.success("资源申请成功，请在个人申请列表中查看");
            return;
          }
        });
      });
    },
    // 收藏
    isCollect(item) {
      let postBody = {
        outSid: item.sid,
        type: 2,
      };
      this.$http({
        url: `api/v1/usershare/collect`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data == 1) {
            window.location.href = `${baseurl.baseUrl}api/v1/sso/toAuthenticate?redirect=${this.$route.fullPath}`;
          } else {
            if (!item.share) {
              this.$message.success("收藏成功");
            }
            if (this.orderField) {
              this.getnewData();
            } else {
              this.getArticleList();
            }
          }
        }
      });
    },
    // 复制
    copyContent(val) {
      this.$copyText(val).then(
        () => {
          this.$message.success("复制成功");
          // 复制成功的操作
        },
        () => {
          this.$message.error("复制失败");
          // 复制失败的操作
        },
      );
    },
    // 导出
    handleExport(type) {
      let url = "";
      if (type == "bib") {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportBibTexReference?sid=" + this.exportSid;
      } else {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportEndNoteReference?sid=" + this.exportSid;
      }
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: localStorage.getItem("jyx_token"),
        },
        url,
      };

      Axios(options).then(res => {
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob); //创建下载的链接
        let a = document.createElement("a");
        a.href = objectUrl;

        // 获取文件名
        let fileName = type == "bib" ? "publication.bib" : "publication.enw";
        fileName = decodeURI(fileName);
        a.download = fileName; //设置文件名
        //下面这个写法兼容火狐
        a.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
        window.URL.revokeObjectURL(blob); //释放bolb对象
      });
    },
    // 馆藏资源跳转
    libdetailUrl(item, bookItem) {
      this.Resourcelist = false;
      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      if (bookItem.shortName == "DOAJ-Directory of Open Access Journals") {
        if (!this.detaildoi) {
          this.detaildoi = item.title;
        }
        let str = '{"query":{"query_string":{"query":"' + this.detaildoi + '","default_operator":"AND"}},"track_total_hits":true}';
        let query = encodeURIComponent(str);
        window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
        return;
      } else {
        this.$http({
          url: "api/v1/wantbuyR/ebook/link?ebookSid=" + bookItem.sid + "&doi=" + this.detaildoi + "&openAlexId=" + item.openAlexId,
          method: "GET",
        }).then(res => {
          if (res.code == 200) {
            window.open(res.data);
          }
        });
      }
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
      return;
    },
    toDetail(index) {
      let item = this.list[index];
      // let doi = val.split("<span style='color:red'>").join("").split("</span>").join("");
      if (item.sid) {
        let _url = this.$router.resolve({
          path: "/articleDetail",
          query: { sid: item.sid },
        });
        window.open(_url.href, "_self");
      } else {
        if (item.detailUrl) {
          window.open(item.detailUrl);
        } else {
          let url = "https://doi.org/" + item.doi;
          window.open(url);
        }
      }
    },
    // 期刊信息跳转
    toHomeDetail(item) {
      let _url = this.$router.resolve({
        path: "/homeDetail",
        query: { sid: item.journalSid },
      });
      window.open(_url.href, "_self");
    },
    bodyCloseMenus(e) {
      // 获取全文里的弹框
      if (this.Resourcelist) {
        this.Resourcelist = false;
      }
    },
    //添加到文件夹
    handleChoiseFolder(index) {
      if (this.folderIndex === index || this.folderList[index].exist) {
        this.folderIndex = null;
        this.folderList[index].exist = false;
      } else {
        this.folderIndex = index;
      }
      this.checkFolder = true;
      this.foldershare = false;
    },
    cannalFolder() {
      this.folderList.shift();
    },
    // 新增文件夹
    submitAddFolder() {
      if (!this.folderList[0].name.trim()) {
        this.$message.error("请输入文件夹名称");
        return;
      }
      const newFolderName = this.folderList[0].name.trim(); // 保存新建文件夹名称
      let postBody = {
        name: newFolderName,
      };
      this.$http({
        url: "/api/v1/ai-service/folder/save",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("新增成功");
          let folderSid = this.folderSid ? this.folderSid : "";
          let foldershare = this.foldershare ? this.foldershare : "";
          // 现在可以使用then了
          this.getFolderList(folderSid, foldershare).then(() => {
            // 查找并选中刚刚新建的文件夹
            for (let i = 0; i < this.folderList.length; i++) {
              if (this.folderList[i].name === newFolderName) {
                this.folderIndex = i;
                this.checkFolder = true;
                break;
              }
            }
          });
          EventBus.$emit("reloadFolder", true);
        }
      });
    },
    // 新建文件夹
    newAddFolder() {
      if (this.folderList.length >= 20) {
        this.$message.error("最多可以创建20个文件夹");
        return;
      }
      if (this.folderList.length > 0) {
        if (!this.folderList[0].name.trim()) {
          return;
        }
      }

      const container = this.$refs.myScroll;
      container.scrollTo({
        top: 0, // 滚动到的位置
        behavior: "smooth", // 平滑滚动效果
      });

      this.folderList.unshift({ name: "", addFlag: true });
    },
    // 单独添加和多选添加共用 将文献添加到文件夹
    submitFolder() {
      if (!this.checkFolder && this.foldershare) {
        this.$message.success(`收藏成功`);
        this.addFodlerDialog = false;
        return;
      }
      // this.folderSid 有值 代表单独添加   没值就是多选添加
      let folderSid = this.folderIndex !== null && this.folderIndex !== undefined ? this.folderList[this.folderIndex].sid : "";
      let sidArray = this.folderSid;
      let postBody = {
        folderSid: folderSid,
        paperSid: sidArray,
      };
      this.$http({
        url: `/api/v1/ai-service/user-literature/collectAddPaper`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (this.folderIndex !== null && this.folderIndex !== undefined) {
          this.$message.success(`成功收藏到"${this.folderList[this.folderIndex].name}"文件夹下`);
        } else {
          this.$message.success(`收藏成功`);
        }
        if (this.orderField) {
          this.getnewData();
        } else {
          this.getArticleList();
        }
        this.addFodlerDialog = false;
      });
    },
    // 添加文献到文件夹
    getFolderList(sid, share) {
      let formData = "";
      // 单个添加文件夹
      if (sid) {
        // document.body.click();
        this.folderSid = sid;
        this.foldershare = share;
        formData = new FormData();
        formData.append("paperSid", sid);
      } else {
        this.folderSid = "";
      }

      // 返回Promise对象
      return new Promise(resolve => {
        this.$http({
          url: `/api/v1/ai-service/folder/paperOptionList`,
          method: "POST",
          data: formData,
        }).then(res => {
          this.folderList = res.data;
          this.folderIndex = null;
          this.checkFolder = false;
          this.addFodlerDialog = true;
          resolve(); // 成功时resolve
        });
      });
    },
    //复制引文
    copylist(id) {
      // 根据当前引文格式获取选中内容
      this.$http({
        url: "api/v1/wantbuyR/copy/context?sid=" + id,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          let copydata = res.data;
          try {
            navigator.clipboard.writeText(copydata).then(() => {
              this.$message.success("已复制,您可随意粘贴使用");
            });
          } catch (err) {
            // 兼容旧浏览器的复制方式
            const textarea = document.createElement("textarea");
            textarea.value = copydata;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$message.success("已复制,您可随意粘贴使用");
          }
        }
      });
    },
    getCode() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.$http({
        url: `api/v1/tourist/check/repeat/mobile?mobile=${this.phone}`,
        method: "get",
      }).then(res => {
        if (res.data) {
          this.times = 60;
          let formData = new FormData();
          formData.append("mobilePhone", this.phone);

          this.$http({
            url: `api/v1/user/sendCode`,
            method: "POST",
            data: formData,
          }).then(res => {
            this.show = false;
            this.timer = setInterval(() => {
              this.times--;
              if (this.times === 0) {
                this.show = true;
                clearInterval(this.timer);
              }
            }, 1000);
          });
        } else {
          this.$message.error("该手机号已存在");
          return;
        }
      });
    },
    submitAddphone() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code.trim()) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: `api/v1/user/changephone`,
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.phoneDialog = false;
          // 绑定成功后自动再次调用getResourceDetail方法
          if (this.currentResourceItem) {
            this.getResourceDetail(this.currentResourceItem);
          }
        }
      });
    },
    // 在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/public.scss";

.page1-main-container {
  display: flex;
  align-items: flex-start;
}

.page1-main {
  flex: 1;
  min-width: 0;

  .right-top {
    margin-bottom: 20px;
    .filter {
      background: #f5f6f7;
      padding: 15px 20px;
      font-size: 14px;
      color: #333;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;

      label {
        background: #fff;
        padding: 5px 10px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        cursor: pointer;

        i {
          margin-left: 5px;
          color: #999;
          &:hover {
            color: #2d8cf0;
          }
        }
      }

      .clear-all {
        color: #2d8cf0;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .search_total {
    display: flex;
    align-items: center;
    font-size: 14px;
    .total {
      color: #86909c;
      span {
        color: #ff0000;
        margin-right: 5px;
      }
    }
    .search {
      background: #fff;
      border: 1px solid #cccccc;
      width: 400px;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        flex: 1;
      }

      .search_img {
        width: 40px;
        height: 30px;
        background: #2c5f97;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  ul {
    li {
      padding: 20px 0;
      border-bottom: 1px dashed #eeeeee;
      .index {
        width: 50px;
        line-height: 30px;
      }
      .right-info {
        color: #666666;
        flex: 1;
        min-width: 0;
        .green {
          color: #2d8cf0;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .mr5 {
          margin-right: 5px;
        }
        .active {
          display: inline-block;
          white-space: nowrap;
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: bottom;
        }
        .undline {
          color: #2d8cf0;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .btn {
          display: flex;
          align-items: center;
        }
        > p {
          line-height: 30px;
          position: relative;
          font-size: 14px;
          .fenhao {
            label {
              &:last-of-type {
                margin: 0 5px;
              }
            }
          }
          &:nth-of-type(1) {
            color: #333;
            font-size: 16px;
            font-weight: 400;
            margin-bottom: 10px;
            cursor: pointer;
            label {
              font-size: 14px;
              padding-left: 5px;
              width: 60px;
              line-height: 22px;
              text-align: center;
              color: white;
              font-weight: initial;
              padding: 2px 5px;
              margin-left: 5px;
            }
          }
          .digestLabel {
            cursor: pointer;
            margin-left: 10px;
            &:hover {
              color: #2d8cf0;
            }
          }
          .span-content {
            position: relative;
            .author-content {
              top: 30px;
              left: 0px;
            }
          }
          .green_span {
            cursor: pointer;
            &:hover {
              .span_a {
                text-decoration: underline;
              }
              transition: all 1s;
              .author-content {
                display: inline-block;
              }
            }
            .span_a {
              color: #2d8cf0;
            }
          }
        }
        .author-content {
          position: absolute;
          background: #fff;
          box-shadow: 0 0 5px #d3d3d3;
          display: none;
          padding: 10px;
          z-index: 9999;
          top: -30px;
          right: -210px;
          min-width: 300px;
          .mb10 {
            font-size: 16px;
            margin-bottom: 10px !important;
          }
          .hui {
            margin-top: 5px !important;
            white-space: pre-wrap;
          }
          p {
            font-size: 14px;
            margin: 0 !important;
            line-height: 20px;
            span {
              position: relative;
              &:first-of-type {
                margin-right: 14px;
                &::before {
                  content: "";
                  position: absolute;
                  width: 1px;
                  height: 14px;
                  background: #ccc;
                  right: -7px;
                  top: 50%;
                  margin-top: -7px;
                }
              }
              label {
                color: #2d8cf0;
              }
            }
          }
        }
        .btn-p {
          align-items: end;
          margin-top: 25px;
          font-size: 14px;
          .num-tips {
            span {
              // color: #2d8cf0;
              margin-left: 5px;
            }
          }
          .share {
            font-style: normal;
            color: #2d8cf0;
            margin-left: 5px;
          }
        }
        .btn-right {
          margin-left: auto;
          display: flex;
          align-items: center;
          font-size: 14px;
          .rotating-image {
            animation: rotate 1s linear infinite;
          }
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
          img {
            margin-right: 5px;
          }
          .checked {
            color: #2d8cf0;
          }
          .noCourse {
            cursor: default !important;
          }
          .flex {
            align-items: center;
            margin-left: 30px;
            cursor: pointer;
            position: relative;
            &:hover {
              color: #2d8cf0;
              text-decoration: underline;
              .hover-img {
                display: inline-block;
              }
              .img {
                display: none;
              }
            }

            .hover-img {
              display: none;
            }
          }
        }
      }
      &:hover {
        .right-info {
          > p {
            &:nth-of-type(1) {
              background-image: linear-gradient(to right, #006eb3, #2d8cf0);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              label {
                -webkit-text-fill-color: initial;
              }
            }
          }
        }
      }

      .achieve {
        background: #ffffff;
        border-radius: 2px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 99999;
        cursor: text;

        &::after {
          content: "";
          position: absolute;
          top: -6px;
          right: 10px;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 10px solid #fff; /* 三角形的颜色 */
        }
        .achieve-li {
          min-width: 270px;
          max-width: 700px;
          overflow-y: auto;
          max-height: 200px;
          padding: 15px 20px;
        }

        li {
          font-size: 16px;
          line-height: 28px;
          padding: 0px;
          border-bottom: 0px;
          a {
            text-decoration: underline;
            color: #2d8cf0;
            cursor: pointer;
          }
          span {
            font-size: 14px;
            color: #b3b3b3;
            margin-left: 5px;
          }
          font {
            color: #b3b3b3;
            font-size: 12px;
            display: block;
            line-height: 20px;
            i {
              margin-right: 5px;
              color: #e6a23c;
            }
          }
          .el-icon-warning {
            color: #e6a23c;
            padding: 0px 10px;
            width: 30px;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 3px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #2d8cf0;
      }
      ::-webkit-scrollbar-track {
        background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
      }
    }
  }
}
::v-deep .el-dialog__header {
  background: #2d8cf0;
  height: 46px;
  line-height: 46px;
  padding: 0;
  padding-left: 30px;
  font-size: 18px;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    right: 15px;
    top: 12px;
    .el-dialog__close {
      color: #fff;
      font-size: 16px;
    }
  }
}
::v-deep .el-dialog__footer {
  text-align: left;
  padding-top: 0;
  padding-bottom: 30px;
  .down-dialog-footer {
    span {
      width: 80px;
      height: 30px;
      display: inline-block;
      text-align: center;
      line-height: 30px;
      margin-left: 10px;
      cursor: pointer;
      background: #f0f7f7;
      color: #2d8cf0;
      &:hover {
        background: #2d8cf0;
        color: #fff;
      }
    }
  }
}
.add_folder_dialog {
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    p {
      padding-left: 20px;
      cursor: pointer;
      i {
        margin-right: 5px;
      }
    }
  }
}
.dialog-content {
  .dialog-tab {
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #333;
    border-bottom: 1px solid #e6e6e6;
    li {
      padding-right: 10px;
      position: relative;
      padding: 0 10px;
      padding-bottom: 5px;
      cursor: pointer;
    }
    .dialogChecked {
      color: #2d8cf0;
      &::before {
        content: "";
        position: absolute;
        bottom: -1px;
        left: 0;
        height: 2px;
        background: #2d8cf0;
        width: 100%;
      }
    }
  }
  .tab1 {
    margin-top: 20px;
    ul {
      max-height: 500px;
      overflow: auto;
      li {
        background: #f7f7f7;
        padding: 30px;
        margin-bottom: 10px;
        &:last-of-type {
          margin: 0;
        }
      }
    }
    ::-webkit-scrollbar {
      display: block;
      width: 8px; /* 定制滚动条的宽度 */
    }
    /* 定制滚动条滑块样式 */
    ::-webkit-scrollbar-thumb {
      background-color: #d9d9d9;
    }
    ::-webkit-scrollbar-track {
      background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
    }

    .flex {
      align-items: center;

      span {
        margin-left: auto;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #2d8cf0;
      }
    }
    .line {
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 20px;
      label {
        color: #333;
        font-weight: bold;
      }
    }
    img {
      width: 17px;
      height: 16px;
      margin-right: 5px;
    }
    .dialog-info {
      color: #333333;
      line-height: 30px;
      margin-top: 20px;
      font-size: 16px;
      white-space: pre-wrap;
    }
  }
}

.add_dialog_folder {
  max-height: 400px;
  overflow-y: auto;
  ul {
    li {
      cursor: pointer;
      color: #333;
      padding: 0px;
      border-bottom: 0px;
      .div_folder {
        height: 40px;
        border-radius: 5px;
        display: flex;
        padding: 0 20px;
        align-items: center;
      }
      .li_folder {
        justify-content: space-between;
        border: 1px solid #fff;
      }
      .new_folder {
        border: 1px solid #2d8cf0;
        ::v-deep .el-input__inner {
          border: none;
          background: none;
          height: 25px;
          color: #333;
          padding: 0;
        }
        span {
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          font-size: 16px;
          margin-left: 10px;
          i {
            color: #868686;
          }
        }
      }
      &:hover {
        background: #f5f6f7;
      }
      img {
        margin-right: 10px;
      }
      i {
        color: #2d8cf0;
        font-size: 18px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  padding: 20px 20px 50px 20px;
}
.phone {
  margin: 20px 0px;
  ::v-deep .el-input {
    .el-input__inner {
      padding-right: 120px;
    }
  }
  align-items: center;
  position: relative;
  .code {
    position: absolute;
    right: 15px;
    padding: 0 20px;
    color: #2d8cf0;
    top: 0;
    line-height: 38px;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 0;
      width: 1px;
      height: 20px;
      background: #c9ebf7;
      content: "";
      top: 10px;
    }
  }
}
.phonebtn {
  display: flex;
  justify-content: flex-end;
}
.literature-dialog-content {
  .literature-tip {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.6;
  }
  .literature-tip-sm {
    font-size: 12px;
    margin-bottom: 20px;
    color: #ff0000;
  }
}
::v-deep .el-dialog__footer .dialog-footer-right {
  text-align: right;
  display: block;
}

::v-deep .el-dialog {
  max-width: calc(100vw - 32px);
}

@media (max-width: 1024px) {
  .page1-main-container {
    flex-direction: column;
    gap: 12px;
  }

  ::v-deep .container_menu {
    width: 100%;
    max-width: none;
    min-height: 0;
    margin-right: 0;

    .menu .menu-list {
      max-height: 280px;
    }
  }

  .page1-main {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .page1-main {
    .right-top {
      margin-bottom: 14px;

      .filter {
        padding: 12px;
        align-items: flex-start;
      }
    }

    .search_total {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;

      .search {
        width: 100%;
        margin-left: 0;
        box-sizing: border-box;
      }
    }

    > ul > li {
      padding: 16px 0;

      > .index {
        width: 32px;
        flex: 0 0 32px;
      }
    }

    ul li .right-info {
      > p {
        line-height: 24px;
        overflow-wrap: anywhere;
      }

      .author-content {
        left: 0;
        right: auto;
        min-width: 0;
        width: min(300px, calc(100vw - 72px));
        box-sizing: border-box;
      }

      .btn-p {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        margin-top: 16px;
      }

      .btn-right {
        width: 100%;
        margin-left: 0;
        flex-wrap: wrap;
        gap: 10px 18px;

        .flex {
          margin-left: 0;
        }
      }
    }

    .achieve {
      left: 0;
      right: auto;
      max-width: calc(100vw - 72px);

      .achieve-li {
        min-width: 0;
        max-width: 100%;
        box-sizing: border-box;
      }
    }
  }

  ::v-deep .el-pagination {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 0;
    white-space: normal;

    .el-pagination__sizes,
    .el-pagination__jump {
      margin-left: 0;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 18px 16px 30px;
  }

  .dialog-content .tab1 ul li {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .page1-main > ul > li > .index {
    display: none;
  }

  ::v-deep .el-pagination {
    .el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__jump {
      display: none;
    }
  }

  .add_folder_dialog ::v-deep .dialog-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
}
</style>
